import { html, LitElement } from 'lit'

import styleUrl from '../../css/styles.css?url'

window.customElements.define(
    'hedelius-mobile-header',
    class HedeliusMobileHeader extends LitElement {
        logo() {
            return html`
                <svg
                    class="h-auto w-[125px]"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 983.07 318.29"
                >
                    <title>hedelius_logo_2</title>
                    <path
                        id="path2465"
                        d="M983.26,20h-945a19,19,0,0,0-19,19V319.27a19,19,0,0,0,19,19h945a19,19,0,0,0,19-19V39a19,19,0,0,0-19-19"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path2469"
                        d="M665.61,298.92a19,19,0,0,0,19-19V81.59a19,19,0,0,0-19-19H77.85a19,19,0,0,0-19,19V279.88a19,19,0,0,0,19,19Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#e0081d"
                    />
                    <path
                        id="path2473"
                        d="M115.2,142.36h15.09V175h35.4v-32.6h15.09v81.38H165.69V189.6h-35.4v34.14H115.2Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path2477"
                        d="M200.73,142.36h46.49V157h-31.4v18.72H246v14.65H215.82v18.71h31.4v14.65H200.73Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path2481"
                        d="M349.51,142.2H396v14.65H364.59v18.73h30.2v14.64h-30.2v18.72H396v14.64H349.51Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path2485"
                        d="M283.48,210.28c9,0,17.28-.33,24.76-5.5,6.65-4.85,10.39-13.41,10.39-21.34,0-8.49-4-17.53-11.44-22.38-7.25-4.63-16.12-4.85-24.53-4.85h-3.54v54.07ZM263.9,142.37H282c12.84.1,26.05,1.31,36.2,9.46,9.46,7.49,14.83,20,14.83,31.61a40.79,40.79,0,0,1-14.83,30.95c-10.39,8.37-22.66,9.36-35.85,9.36H263.9Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path2489"
                        d="M410.39,142.36h15.09v66.73h27.26v14.65H410.39Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path2491"
                        d="M467.11,142.36H482.2v81.38H467.11Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path2495"
                        d="M518.52,142.36v50.77c0,3.74-.23,7.59,1.54,11,2.2,4.17,10,8,14.84,8,4.53,0,12.69-3.25,14.9-6.78,2.31-3.75,2.2-7.92,2.2-12.22V142.36h15.08v50.77c0,8-1.44,15.63-6.73,22s-16.69,9.4-25,9.4c-7.71,0-19.51-3-24.57-8.73-5.95-6.73-7.4-14.22-7.4-22.69V142.36Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path2499"
                        d="M593.32,201.84s4.8,9.83,15.38,10.6c8.13.59,11.61-5,12.15-11,.9-9.94-7.74-12.74-16-15.37-5.65-1.79-10.5-3.34-14.78-7.58a24,24,0,0,1-6.69-16.22c0-13.49,10-21.09,23.63-22,19.93-1.27,25,14.15,25,14.15l-10.32,5.12c-3.7-6.38-9.15-7.84-14.11-7.84-5.2,0-11.29,4.28-11.18,9.18-.11,6,6.6,10.73,11.68,12.4,6,2,14.13,4.74,19,8.65,6.12,4.67,8.47,8.72,8.47,16.75,0,14.71-11.83,26.34-27.72,26.08-20.09-.33-25.92-17.2-25.92-17.2Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path2503"
                        d="M993.29,313.91a15.22,15.22,0,0,1-15.23,15.22H43.16a15.23,15.23,0,0,1-15.24-15.22V43.54A15.25,15.25,0,0,1,43.16,28.3h934.9a15.24,15.24,0,0,1,15.23,15.24ZM983.26,20h-945a19,19,0,0,0-19,19V319.26a19,19,0,0,0,19,19h945a19,19,0,0,0,19-19V39a19,19,0,0,0-19-19"
                        transform="translate(-19.23 -20.01)"
                    />
                    <path
                        id="path2507"
                        d="M844.4,300.09A121.82,121.82,0,1,0,722.58,178.28,121.82,121.82,0,0,0,844.4,300.09"
                        transform="translate(-19.23 -20.01)"
                    />
                    <path
                        id="path2511"
                        d="M844.4,297.43A119.16,119.16,0,1,0,725.25,178.27,119.17,119.17,0,0,0,844.4,297.43"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path2515"
                        d="M844.4,286.49A108.22,108.22,0,1,1,952.61,178.27,108.23,108.23,0,0,1,844.4,286.49m0-219.19a111,111,0,1,0,111,111,111,111,0,0,0-111-111"
                        transform="translate(-19.23 -20.01)"
                    />
                    <path
                        id="path2519"
                        d="M853.11,156.09a55.8,55.8,0,0,0,2.46,15.09l-.19-.86s.25,1,.25,1a53.07,53.07,0,0,0,3.46,8.45l-.41-.77c.13,0,.51.69.51.69l53.19,97.06.59,1.08-1,.68c-2.36,1.6-4,2.69-6.55,4.16l.11-.09a4.05,4.05,0,0,1-3,.66,5.33,5.33,0,0,1-3.42-2.71l-2.68-4.37,0-.1,0-.09a1.75,1.75,0,0,0-.86-.81,2.21,2.21,0,0,0-1.7.22c-.63.29-1.24.6-1.89.93s-1.18.59-1.79.87A108.81,108.81,0,0,1,779.7,266a108.91,108.91,0,0,1-26.8-28.52l-.23-.35v-.59l2.26-1A47.59,47.59,0,0,0,835.14,201a58.11,58.11,0,0,0-3.64-18.61l.07.13-3.63-7.11-52.08-95-.58-1.07,1-.68c2.36-1.62,4-2.7,6.55-4.16l-.12.08a4.1,4.1,0,0,1,3-.66,5.24,5.24,0,0,1,3.41,2.72L791.87,81l0,.09,0,.1a1.86,1.86,0,0,0,.85.81,2.38,2.38,0,0,0,1.71-.23c.63-.29,1.25-.59,1.89-.92s1.18-.6,1.79-.89A108.85,108.85,0,0,1,908.54,91.11a109.24,109.24,0,0,1,26.81,28.51l.22.35,0,.42v.19l-2.27.93a47.66,47.66,0,0,0-80.17,34.58"
                        transform="translate(-19.23 -20.01)"
                        fill="#cfd0d2"
                    />
                    <path
                        id="path2523"
                        d="M934.61,120.23a49,49,0,0,0-82.46,35.54,60,60,0,0,0,4.38,20.79l-25.91,0L777.43,79.45c2.38-1.61,4-2.65,6.47-4.1,0,0,2.42-1.79,4.53,1.68l2.68,4.37s1.14,2.76,4.36,1.3c1.23-.58,2.45-1.23,3.69-1.81a107.51,107.51,0,0,1,109,11A108.22,108.22,0,0,1,934.61,120ZM911.6,277c-2.38,1.62-4,2.66-6.48,4.11,0,0-2.41,1.78-4.53-1.68l-2.68-4.37s-1.14-2.76-4.34-1.3c-1.26.58-2.46,1.23-3.7,1.81a107.51,107.51,0,0,1-109-11,108,108,0,0,1-26.47-28.17v-.19a49,49,0,0,0,82.45-35.54,59.49,59.49,0,0,0-3.72-19.09h.09l-.1-.23v.22c-.21-.57-.42-1.15-.65-1.68l25.91,0Zm28.1-155.28c-2-4-2.16-3.61-2.16-3.61A111,111,0,0,0,797.69,77.72l-1.85.9c-.28.14-.54.3-.83.42-1.1.47-1.41-.26-1.41-.26l-2.19-3.58a7.34,7.34,0,0,0-4.84-3.69,5,5,0,0,0-.77,0,31,31,0,0,0-3.35,1.9s-.14,0-.05-.06c-2.56,1.48-9.12,5.9-9.12,5.9l1.09,1.89,52.31,95.32.92,1.7h-.16a26.93,26.93,0,0,1,2.38,5,44.71,44.71,0,0,1,3.57,17.61,45.55,45.55,0,0,1-73.55,35.61,22.44,22.44,0,0,0-4.91-3.27,16.1,16.1,0,0,0-7.57-1.56l2,3.24c2,4,2.17,3.6,2.17,3.6a111,111,0,0,0,139.85,40.43c.64-.3,1.26-.61,1.84-.91.28-.13.56-.29.83-.41,1.12-.47,1.42.25,1.42.25.76,1.27,2.19,3.59,2.19,3.59a7.34,7.34,0,0,0,4.83,3.69,6.82,6.82,0,0,0,.78,0,31.48,31.48,0,0,0,3.36-1.92s.14,0,0,.08c2.56-1.49,9.12-5.91,9.12-5.91l-1.09-1.89L862.35,180l-.94-1.7h.17a28.35,28.35,0,0,1-2.38-4.94,45.27,45.27,0,0,1,41.68-62.84,45.55,45.55,0,0,1,28.31,9.61,22.3,22.3,0,0,0,4.91,3.28,16.08,16.08,0,0,0,7.57,1.56Z"
                        transform="translate(-19.23 -20.01)"
                    />
                    <path
                        id="path3631"
                        d="M983.26,20h-945a19,19,0,0,0-19,19V319.27a19,19,0,0,0,19,19h945a19,19,0,0,0,19-19V39a19,19,0,0,0-19-19"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path3635"
                        d="M665.61,298.92a19,19,0,0,0,19-19V81.59a19,19,0,0,0-19-19H77.85a19,19,0,0,0-19,19V279.88a19,19,0,0,0,19,19Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#e0081d"
                    />
                    <path
                        id="path3639"
                        d="M115.2,142.36h15.09V175h35.4v-32.6h15.09v81.38H165.69V189.6h-35.4v34.14H115.2Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path3643"
                        d="M200.73,142.36h46.49V157h-31.4v18.72H246v14.65H215.82v18.71h31.4v14.65H200.73Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path3647"
                        d="M349.51,142.2H396v14.65H364.59v18.73h30.2v14.64h-30.2v18.72H396v14.64H349.51Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path3651"
                        d="M283.48,210.28c9,0,17.28-.33,24.76-5.5,6.65-4.85,10.39-13.41,10.39-21.34,0-8.49-4-17.53-11.44-22.38-7.25-4.63-16.12-4.85-24.53-4.85h-3.54v54.07ZM263.9,142.37H282c12.84.1,26.05,1.31,36.2,9.46,9.46,7.49,14.83,20,14.83,31.61a40.79,40.79,0,0,1-14.83,30.95c-10.39,8.37-22.66,9.36-35.85,9.36H263.9Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path3655"
                        d="M410.39,142.36h15.09v66.73h27.26v14.65H410.39Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path3657"
                        d="M467.11,142.36H482.2v81.38H467.11Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path3661"
                        d="M518.52,142.36v50.77c0,3.74-.23,7.59,1.54,11,2.2,4.17,10,8,14.84,8,4.53,0,12.69-3.25,14.9-6.78,2.31-3.75,2.2-7.92,2.2-12.22V142.36h15.08v50.77c0,8-1.44,15.63-6.73,22s-16.69,9.4-25,9.4c-7.71,0-19.51-3-24.57-8.73-5.95-6.73-7.4-14.22-7.4-22.69V142.36Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path3665"
                        d="M593.32,201.84s4.8,9.83,15.38,10.6c8.13.59,11.61-5,12.15-11,.9-9.94-7.74-12.74-16-15.37-5.65-1.79-10.5-3.34-14.78-7.58a24,24,0,0,1-6.69-16.22c0-13.49,10-21.09,23.63-22,19.93-1.27,25,14.15,25,14.15l-10.32,5.12c-3.7-6.38-9.15-7.84-14.11-7.84-5.2,0-11.29,4.28-11.18,9.18-.11,6,6.6,10.73,11.68,12.4,6,2,14.13,4.74,19,8.65,6.12,4.67,8.47,8.72,8.47,16.75,0,14.71-11.83,26.34-27.72,26.08-20.09-.33-25.92-17.2-25.92-17.2Z"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path3669"
                        d="M993.29,313.91a15.22,15.22,0,0,1-15.23,15.22H43.16a15.23,15.23,0,0,1-15.24-15.22V43.54A15.25,15.25,0,0,1,43.16,28.3h934.9a15.24,15.24,0,0,1,15.23,15.24ZM983.26,20h-945a19,19,0,0,0-19,19V319.26a19,19,0,0,0,19,19h945a19,19,0,0,0,19-19V39a19,19,0,0,0-19-19"
                        transform="translate(-19.23 -20.01)"
                    />
                    <path
                        id="path3673"
                        d="M844.4,300.09A121.82,121.82,0,1,0,722.58,178.28,121.82,121.82,0,0,0,844.4,300.09"
                        transform="translate(-19.23 -20.01)"
                    />
                    <path
                        id="path3677"
                        d="M844.4,297.43A119.16,119.16,0,1,0,725.25,178.27,119.17,119.17,0,0,0,844.4,297.43"
                        transform="translate(-19.23 -20.01)"
                        fill="#fff"
                    />
                    <path
                        id="path3681"
                        d="M844.4,286.49A108.22,108.22,0,1,1,952.61,178.27,108.23,108.23,0,0,1,844.4,286.49m0-219.19a111,111,0,1,0,111,111,111,111,0,0,0-111-111"
                        transform="translate(-19.23 -20.01)"
                    />
                    <path
                        id="path3685"
                        d="M853.11,156.09a55.8,55.8,0,0,0,2.46,15.09l-.19-.86s.25,1,.25,1a53.07,53.07,0,0,0,3.46,8.45l-.41-.77c.13,0,.51.69.51.69l53.19,97.06.59,1.08-1,.68c-2.36,1.6-4,2.69-6.55,4.16l.11-.09a4.05,4.05,0,0,1-3,.66,5.33,5.33,0,0,1-3.42-2.71l-2.68-4.37,0-.1,0-.09a1.75,1.75,0,0,0-.86-.81,2.21,2.21,0,0,0-1.7.22c-.63.29-1.24.6-1.89.93s-1.18.59-1.79.87A108.81,108.81,0,0,1,779.7,266a108.91,108.91,0,0,1-26.8-28.52l-.23-.35v-.59l2.26-1A47.59,47.59,0,0,0,835.14,201a58.11,58.11,0,0,0-3.64-18.61l.07.13-3.63-7.11-52.08-95-.58-1.07,1-.68c2.36-1.62,4-2.7,6.55-4.16l-.12.08a4.1,4.1,0,0,1,3-.66,5.24,5.24,0,0,1,3.41,2.72L791.87,81l0,.09,0,.1a1.86,1.86,0,0,0,.85.81,2.38,2.38,0,0,0,1.71-.23c.63-.29,1.25-.59,1.89-.92s1.18-.6,1.79-.89A108.85,108.85,0,0,1,908.54,91.11a109.24,109.24,0,0,1,26.81,28.51l.22.35,0,.42v.19l-2.27.93a47.66,47.66,0,0,0-80.17,34.58"
                        transform="translate(-19.23 -20.01)"
                        fill="#cfd0d2"
                    />
                    <path
                        id="path3689"
                        d="M934.61,120.23a49,49,0,0,0-82.46,35.54,60,60,0,0,0,4.38,20.79l-25.91,0L777.43,79.45c2.38-1.61,4-2.65,6.47-4.1,0,0,2.42-1.79,4.53,1.68l2.68,4.37s1.14,2.76,4.36,1.3c1.23-.58,2.45-1.23,3.69-1.81a107.51,107.51,0,0,1,109,11A108.22,108.22,0,0,1,934.61,120ZM911.6,277c-2.38,1.62-4,2.66-6.48,4.11,0,0-2.41,1.78-4.53-1.68l-2.68-4.37s-1.14-2.76-4.34-1.3c-1.26.58-2.46,1.23-3.7,1.81a107.51,107.51,0,0,1-109-11,108,108,0,0,1-26.47-28.17v-.19a49,49,0,0,0,82.45-35.54,59.49,59.49,0,0,0-3.72-19.09h.09l-.1-.23v.22c-.21-.57-.42-1.15-.65-1.68l25.91,0Zm28.1-155.28c-2-4-2.16-3.61-2.16-3.61A111,111,0,0,0,797.69,77.72l-1.85.9c-.28.14-.54.3-.83.42-1.1.47-1.41-.26-1.41-.26l-2.19-3.58a7.34,7.34,0,0,0-4.84-3.69,5,5,0,0,0-.77,0,31,31,0,0,0-3.35,1.9s-.14,0-.05-.06c-2.56,1.48-9.12,5.9-9.12,5.9l1.09,1.89,52.31,95.32.92,1.7h-.16a26.93,26.93,0,0,1,2.38,5,44.71,44.71,0,0,1,3.57,17.61,45.55,45.55,0,0,1-73.55,35.61,22.44,22.44,0,0,0-4.91-3.27,16.1,16.1,0,0,0-7.57-1.56l2,3.24c2,4,2.17,3.6,2.17,3.6a111,111,0,0,0,139.85,40.43c.64-.3,1.26-.61,1.84-.91.28-.13.56-.29.83-.41,1.12-.47,1.42.25,1.42.25.76,1.27,2.19,3.59,2.19,3.59a7.34,7.34,0,0,0,4.83,3.69,6.82,6.82,0,0,0,.78,0,31.48,31.48,0,0,0,3.36-1.92s.14,0,0,.08c2.56-1.49,9.12-5.91,9.12-5.91l-1.09-1.89L862.35,180l-.94-1.7h.17a28.35,28.35,0,0,1-2.38-4.94,45.27,45.27,0,0,1,41.68-62.84,45.55,45.55,0,0,1,28.31,9.61,22.3,22.3,0,0,0,4.91,3.28,16.08,16.08,0,0,0,7.57,1.56Z"
                        transform="translate(-19.23 -20.01)"
                    />
                </svg>
            `
        }

        closeButton() {
            return html`
                <button data-menu-close-button class="h-full w-auto hover:text-hdls-red">
                    <svg
                        class="h-full w-auto"
                        fill="none"
                        stroke="currentColor"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 29.8"
                    >
                        <g>
                            <line
                                style="stroke-width: 1px;"
                                x1="9.85"
                                y1="9.85"
                                x2="19.95"
                                y2="19.95"
                            />
                            <line
                                style="stroke-width: 1px;"
                                x1="19.95"
                                y1="9.85"
                                x2="9.85"
                                y2="19.95"
                            />
                        </g>
                    </svg>
                </button>
            `
        }

        render() {
            return html`
                <link rel="stylesheet" href="${styleUrl}" />
                <div
                    class="sticky left-0 top-0 z-[1000] flex h-[60px] w-full flex-1 items-center justify-between border-b-2 border-white border-opacity-50 bg-transparent px-5 text-hdls-on-white shadow backdrop-blur-md md:hidden"
                >
                    ${this.logo()} ${this.closeButton()}
                </div>
            `
        }
    }
)
